import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useNavigate } from 'react-router-dom';

function TitileAndArrowBack(props) {
    const navigate = useNavigate();

    const goBack = () => {
        navigate(-1);
    };
    const showOnRegisterAd = useLocation()
    console.log('showOnRegisterAd', showOnRegisterAd);

    return (
        // <div className={`w-full items-center justify-center  py-2 z-40 sticky 
        <div className={`w-full items-center justify-center  py-2  sticky 
        sm:relative bg-white border-b  top-0 ${showOnRegisterAd.pathname != "/RegisterAD" && 'hidden'}  sm:flex md:flex lg:flex`}>
            <h1 className='w-full text-center font-bold '>{props.title}</h1>
            {
                props.setIsDateVisible ? (
                    <div  className='absolute right-4' onClick={()=>props.setIsDateVisible(false)}>
                        <img src='/icons/arrow-right.svg' alt='icon-right' className='' />
                    </div>
                ) : (
                    <Link to={props.link} className='absolute flex items-center right-4 top-2' onClick={goBack}>
                        <img src='/icons/arrow-right.svg' alt='icon-right' className=' top-0' />
                    </Link>
                )
            }
        </div>
    )
}

export default TitileAndArrowBack